module.exports = __webpack_public_path__ + "img/7mojosgame.5bde0f58.png";